import React from 'react';
import '../assets/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 ICNPA. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
